import React from 'react';
import { ApplePayRadio } from '@fff-web/fff-ui-shared/Icon';
import styles from './SubmitBtn.module.css';

interface ApplePayButtonProps {
  handleApplePay: () => void;
  disabled: boolean;
}

const ApplePayButton: React.FunctionComponent<ApplePayButtonProps> = ({
  handleApplePay,
  disabled,
}) => (
  <button type="button" onClick={handleApplePay} className={styles.applePay} disabled={disabled}>
    Check Out with
    <ApplePayRadio />
  </button>
);

export default ApplePayButton;
